import React from "react"
import { useNavigate } from "react-router-dom"
import Image09 from "../assets/Image09.jpg"
import Image10 from "../assets/Image10.jpg"
import leavesInGutters from "../assets/leavesInGutters.png"
import cloggedGutters from "../assets/cloggedGutters.jpg"
import leakySeams from "../assets/leakySeams.jpg"
import saggingGutter from "../assets/saggingGutter.jpg"
import damagedDownspout from "../assets/damagedDownspout.jpg"
import rustedGutterwithHoles from "../assets/rustedGutterwithHoles.jpg"
import { MessageSquare } from "lucide-react"
import "./styles/CleaningAndRepairs.css"

function CleaningAndRepairs() {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  return (
    <div className="cleaning-and-repairs">
      <h1>
        Gutter Maintenance Free from Leaves & Debris is a Frequent Challenge.
      </h1>
      <div className="two-columns">
        <div className="left-column">
          <img src={leavesInGutters} alt="leaves in gutter" />
        </div>

        <div className="right-column">
          <p>
            Yet, there are times when they need more than just cleaning; they
            need repairs. Issues often arise with gutter end caps, mitered
            corners, or other parts of seamed sections, leading to leaks.{" "}
          </p>
          <p>
            It&rsquo;s not uncommon for a gutter to become loose, or for the
            leader assemblies to get dislodged or even fall off. Such situations
            necessitate re-hanging, repairing, or sometimes a complete
            replacement.{" "}
          </p>
          <p>
            It&rsquo;s essential to address these repairs timely to ensure the
            gutters function effectively. Neglecting gutter issues can lead to
            significant damage, as water might infiltrate basements and crawl
            spaces, damaging fascia boards, siding, and even compromising the
            foundation.
          </p>
        </div>
      </div>
      <h2>
        Manny&rsquo;s Seamless Gutters, Inc. Can Help with All Gutter Repairs
      </h2>
      <div className="five-images-and-paragraphs">
        <div className="image-and-paragraph">
          <img
            src={cloggedGutters}
            alt="clogged gutter with overpooling water"
          />
          <p>
            Clogged Gutters: Clogged gutters are perhaps the most frequent issue
            homeowners face the most. Over time, leaves, twigs, and other debris
            can accumulate, preventing water from flowing freely. Regular
            cleaning, especially after the fall season, can prevent water damage
            and extend the life of your gutters.
          </p>
        </div>
        <div className="image-and-paragraph">
          <img src={leakySeams} alt="gutter with leaky seams" />
          <p>
            Leaky Seams or Corners: Over time, the seams or corners of gutters
            can start to leak due to wear and tear or poor installation. This
            can lead to water dripping, potentially damaging the home&rsquo;s
            foundation or landscaping. Sealing or replacing the affected
            sections can address this issue. 2
          </p>
        </div>
        <div className="image-and-paragraph">
          <img src={saggingGutter} alt="a sagging warped gutter" />
          <p>
            Sagging Gutters: Gutters that aren&apos;t properly supported or that
            are weighed down by debris can begin to sag. This not only affects
            the appearance of your home but can also lead to ineffective water
            drainage. Installing or adjusting hangers can usually fix this
            problem.
          </p>
        </div>
        <div className="image-and-paragraph">
          <img
            src={damagedDownspout}
            alt="bent downspout with water in all directions"
          />
          <p>
            Damaged Downspouts: Downspouts play a crucial role in directing
            water away from the foundation. If they become damaged or clogged,
            it can result in pooling water around the base of your home. Regular
            inspections and clearing blockages or replacing damaged sections can
            ensure effective water flow.
          </p>
        </div>
        <div className="image-and-paragraph">
          <img src={rustedGutterwithHoles} alt="rusty gutter with holes" />
          <p>
            Holes or Rust Spots: Metal gutters, especially older ones, can
            develop holes or rust spots. These compromised areas can lead to
            water leaks, which can damage the exterior of your home. Patching
            small holes or replacing larger sections can help maintain the
            integrity of the gutter system. Manny&apos;s Seamless Gutters, Inc.
            is equipped to handle all these common repairs, ensuring your
            gutters remain in top condition and continue to protect your home
            effectively.
          </p>
        </div>
      </div>
      <div className="two-paragraphs-and-image">
        <div className="two-paragraphs">
          <h2>Fascia &amp; Soffit Maintenance Renewal:</h2>
          <p>
            A malfunctioning gutter system can lead to water and ice
            accumulating against the fascias, potentially damaging both the
            fascia boards and soffits. The fascia board is a horizontal piece
            affixed to the rafter ends, right above the roof&rsquo;s edge. This
            board encloses the roof&rsquo;s overhang beneath the eave, and
            it&rsquo;s where the gutters are mounted.
          </p>
          <p>
            From a distance, it might seem that the fascia boards and soffits
            merely need a fresh paint job. However, the strain from the gutters
            or accumulated debris can cause the fastening nails to loosen over
            time. This can lead to the gutter tilting, creating a gap between it
            and the fascia board. Consequently, water can trickle down the
            fascia, spreading to the soffit. This not only harms the fascia but
            can also seep along the foundation or even into the ceiling. A
            detailed examination often reveals that the wood is irreparable and
            requires replacement.
          </p>
        </div>
        <div className="right-image">
          <img src={Image10} alt="Right Image" className="secondTolast" />
        </div>
      </div>

      <div className="two-columns">
        <div className="left-column">
          <img src={Image09} alt="Left Column Image" />
        </div>
        <div className="right-column">
          <p>
            Our team of gutter maintenance professionals will carefully remove
            the eave&apos;s fascia board and clear out any accumulated debris.
            They&apos;ll also take out the flashing and replace any damaged
            under-soffit plywood. Any deteriorated or compromised boards are
            removed, and new flashing, fascia boards, and soffit vents are set
            in place.
          </p>
          <p>
            Soffit vents, typically rectangular and located on the soffit&apos;s
            underside, are essential for ventilation. Made of materials like
            vinyl or aluminum, they come with a protective mesh to deter pests
            like bees from infesting your attic. Overlooked soffits can become a
            breeding ground for pests and decay, compromising the home&rsquo;s
            structural integrity.
          </p>
          <p>
            We provide a range of soffit materials, including plywood, vinyl,
            and aluminum. Alternatively, we can replicate the existing soffit
            using materials like tongue-and-groove beaded board. Our company is
            equipped to either replace worn-out materials, safeguarding your
            home from external elements, or upgrade your home with new fascias
            and soffits to enhance its aesthetic and market value.
          </p>
        </div>
      </div>

      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
    </div>
  )
}

export default CleaningAndRepairs
